import { PositionOverview } from './types'
import { NativeAssetInfo } from '@/config/chain/types'
import { DialogFormNormalizedData } from '@/features/dialogs/common/logic/form'
import { AaveData } from '@/features/sparklend/common/data/market-info/aave-data-layer/query'
import { MarketInfo } from '@/features/sparklend/common/data/market-info/marketInfo'
import { calculateLiquidityRate, rateToYield } from '@/features/sparklend/common/data/market-info/math'
import { updatePositionSummary } from '@/features/sparklend/common/data/market-info/updatePositionSummary'

export interface CalculateUpdatePositionOverviewParams {
  tokenToDeposit: DialogFormNormalizedData
  marketInfo: MarketInfo
  aaveData: AaveData
  nativeAssetInfo: NativeAssetInfo
  currentPositionOverview: PositionOverview
}

export function calculateUpdatePositionOverview({
  tokenToDeposit,
  marketInfo,
  aaveData,
  nativeAssetInfo,
  currentPositionOverview,
}: CalculateUpdatePositionOverviewParams): PositionOverview | undefined {
  const updatedUserSummary = updatePositionSummary({
    deposits: [tokenToDeposit],
    marketInfo,
    aaveData,
    nativeAssetInfo,
  })

  const currentSupplyApy = tokenToDeposit.reserve.supplyAPY
  const updatedSupplyApy = rateToYield(
    calculateLiquidityRate({
      ...tokenToDeposit.reserve,
      availableLiquidity: tokenToDeposit.reserve.availableLiquidity.plus(tokenToDeposit.value),
    }),
  )
  const significantSupplyDifference = currentSupplyApy
    ? updatedSupplyApy.minus(currentSupplyApy).abs().gt(0.0001)
    : undefined

  const updatedPositionOverview: PositionOverview | undefined = tokenToDeposit.value.eq(0)
    ? undefined
    : {
        ...currentPositionOverview,
        healthFactor: updatedUserSummary.healthFactor,
        supplied: currentPositionOverview.supplied.plus(tokenToDeposit.value),
        supplyAPY: significantSupplyDifference ? updatedSupplyApy : currentSupplyApy, // pretend it's the same if the difference is less than 0.01%
      }

  return updatedPositionOverview
}
